import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=c706df50&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=ts"
export * from "./UserHome.vue?vue&type=script&lang=ts"
import style0 from "./UserHome.vue?vue&type=style&index=0&id=c706df50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c706df50",
  null
  
)

export default component.exports